import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import Moment from "moment";
import ReactTooltip from "react-tooltip";
import _ from "lodash";
import Http from "axios";
import Dropzone from "react-dropzone";
import config from "../config";

@inject("UserStore")
@observer
class History extends Component {
  state = {
    statusModal: false,
    insuranceImage: {}
  };

  componentDidMount() {
    this.props.UserStore.getOrder(this.props.match.params.id);
  }

  onDropInsurance = file => {
    this.setState({
      insuranceImage: file[0]
    });
  };

  updateInsurance = async () => {
    const { selectedOrder } = this.props.UserStore;
    const url = await Http.post(
      config.api + "/sign/insurance",
      {
        objectName: this.state.insuranceImage.name,
        contentType: this.state.insuranceImage.type
      },
      {
        withCredentials: true
      }
    );
    const options = {
      headers: {
        "Content-Type": this.state.insuranceImage.type
      },
      onUploadProgress: progress => {
        console.log(progress);
      }
    };

    console.log(url.data.result[0].fileKey);

    await Http.put(
      url.data.result[0].signedUrl,
      this.state.insuranceImage,
      options
    );

    await Http.post(
      `${config.api}/orders/${selectedOrder._id}/insurance`,
      {
        url: url.data.result[0].fileKey
      },
      {
        withCredentials: true
      }
    );
  };

  getOrderRange = products => {
    const startDate = products.reduce((startDate, product) => {
      const prevDate = Moment(startDate);
      const currentDate = Moment(product.startsAt);
      return currentDate.isBefore(prevDate) ? product.startsAt : prevDate;
    }, Date.now());
    const endDate = products.reduce((endDate, product) => {
      const prevDate = Moment(endDate);
      const currentDate = Moment(product.endsAt);
      return currentDate.isAfter(prevDate) ? product.endsAt : prevDate;
    }, Date.now());

    return {
      startDate: Moment(startDate).format("MMM DD, YYYY"),
      endDate: Moment(endDate).format("MMM DD, YYYY")
    };
  };

  getDepositedValue = order => {
    const partialStatuses = ["deposited", "prepared"];
    const completeStatuses = ["checkedOut", "completed"];
    if (order.status === "insurancePending" || order.status === "cancelled") {
      return 0;
    } else if (partialStatuses.indexOf(order.status) > -1) {
      return order.value * 0.25;
    } else if (completeStatuses.indexOf(order.status) > -1) {
      return order.value;
    } else {
      return 0;
    }
  };

  truncateText = (text, length) =>
    text.length > length ? `${text.slice(0, length).trim()}...` : text;

  toggleStatusModal = () => {
    const { selectedOrder } = this.props.UserStore;
    if (
      selectedOrder.status !== "completed" &&
      selectedOrder.status !== "cancelled"
    ) {
      this.setState({
        statusModal: !this.state.statusModal
      });
    }
  };

  nextOrderStatus = async () => {
    const { selectedOrder } = this.props.UserStore;
    const { insuranceImage } = this.state;
    if (selectedOrder.status === "insurancePending" && insuranceImage.name) {
      await this.updateInsurance();
    }
    const { data } = await Http.post(
      `${config.api}/admin/orders/${selectedOrder._id}`,
      {},
      { withCredentials: true }
    );
    this.props.UserStore.setOrder(data.result);
    this.toggleStatusModal();
  };

  render() {
    const { selectedOrder } = this.props.UserStore;
    const { startDate, endDate } = this.getOrderRange(
      selectedOrder.products ? selectedOrder.products : []
    );
    return (
      <div className="main-content">
        <div className="section-title standalone">
          <p>ORDER DETAILS</p>
          <div className="sep" />
        </div>

        <div className="history">
          <div className="history-details">
            <p className="history-title">Order: {selectedOrder.orderNumber}</p>
            <div className="history-details-divider" />
            {selectedOrder.status ? (
              <div className="history-details-status">
                <div className="history-side">
                  <p className="history-status-item">
                    <b>Order Placed:</b>{" "}
                    {Moment(selectedOrder.created_at).format("MMM DD, YYYY")}
                  </p>
                  <p className="history-status-item">
                    <b>Pickup:</b> {Moment(startDate).format("MMM DD, YYYY")}
                  </p>
                  <p className="history-status-item">
                    <b>Return:</b> {Moment(endDate).format("MMM DD, YYYY")}
                  </p>
                  <p className="history-status-item">
                    <b>Status:</b>{" "}
                    <span
                      className="highlighted-btn"
                      onClick={this.toggleStatusModal}
                    >
                      {_.startCase(selectedOrder.status)}
                    </span>
                  </p>
                </div>
                <div className="history-side">
                  <p className="history-status-item">
                    <b>Order Total:</b> ${selectedOrder.value.toFixed(2)}
                  </p>
                  <p className="history-status-item">
                    <b>Deposit:</b> $
                    {this.getDepositedValue(selectedOrder).toFixed(2)}
                  </p>
                </div>
              </div>
            ) : null}
          </div>
          <div className="head-entry entry head-entry-order">
            <p className="order-item-head">Item</p>
            <p>Quantity</p>
            <p>Price Per Day</p>
            <p>Price for selected range</p>
          </div>
          {selectedOrder.products
            ? selectedOrder.products.map(orderProduct => (
                <div className="entry-order-item">
                  <div className="item-details">
                    <div
                      className="item-image"
                      style={{
                        backgroundImage: `url(${
                          orderProduct.product.images[0]
                        })`
                      }}
                    />
                    <div className="item-info">
                      <p className="item-name">{orderProduct.product.name}</p>
                      <p className="item-desc">
                        {this.truncateText(
                          orderProduct.product.description,
                          100
                        )}
                      </p>
                    </div>
                  </div>
                  <p className="entry-order-qty">{orderProduct.qty} Pieces</p>
                  <p className="entry-order-price-unit">
                    ${orderProduct.product.pricePerDay.toFixed(2)}/day
                  </p>
                  <p className="entry-order-price-unit">
                    ${orderProduct.price.toFixed(2)} for selected range
                  </p>
                </div>
              ))
            : null}
        </div>

        {selectedOrder.status ? (
          <div
            className={
              "status-modal" + (this.state.statusModal ? " modal-visible" : "")
            }
          >
            <div className="modal-overlay" onClick={this.toggleStatusModal} />
            <div className="status-container">
              <div className="modal-header">
                <p className="modal-title">Insurance Pending Approval</p>
                <div
                  className="modal-close-btn"
                  onClick={this.toggleStatusModal}
                >
                  <i className="fa fa-close" />
                </div>
              </div>
              {selectedOrder.status === "insurancePending" ? (
                <div className="modal-body">
                  <div className="insurance-upload">
                    <a
                      href={
                        this.state.insuranceImage.preview
                          ? this.state.insuranceImage.preview
                          : selectedOrder.insurance
                          ? selectedOrder.insurance
                          : "#"
                      }
                      target="_blank"
                    >
                      <div className="insurance-preview">
                        <div className="insurance-icon">
                          {this.state.insuranceImage.preview ||
                          selectedOrder.insurance
                            ? this.state.insuranceImage.name ||
                              selectedOrder.insurance
                                .split("_")[1]
                                .split("?")[0]
                            : "UPLOAD INSURANCE"}
                        </div>{" "}
                      </div>
                    </a>
                    <Dropzone
                      onDrop={this.onDropInsurance}
                      multiple={false}
                      style={{
                        width: "100%",
                        border: 0
                      }}
                      ref="insuranceUpload"
                    >
                      <div className="insurance-upload-btn">
                        UPLOAD INSURANCE
                      </div>
                    </Dropzone>
                  </div>
                  <div className="insurance-details">
                    <p>
                      Insurance needs to cover:{" "}
                      <span className="highlighted-text">
                        ${selectedOrder.value.toFixed(2)}{" "}
                        <i
                          className="fa fa-info-circle"
                          data-tip="Actual value of rented equipment"
                          data-type="info"
                        />
                      </span>
                    </p>
                    <p>
                      And must be valid from:
                      <br />{" "}
                      <span className="highlighted-text">
                        {Moment(startDate).format("MMM DD, YYYY")}{" "}
                        <i
                          className="fa fa-info-circle"
                          data-tip="Pickup Date"
                          data-type="info"
                        />
                      </span>{" "}
                      until{" "}
                      <span className="highlighted-text">
                        {Moment(startDate).format("MMM DD, YYYY")}{" "}
                        <i
                          className="fa fa-info-circle"
                          data-tip="Return Date"
                          data-type="info"
                        />
                      </span>
                    </p>
                    <p>
                      Make sure Stareway Films, LLC. Is listed as the
                      Certificate Holder or the Loss payee.
                    </p>
                  </div>
                </div>
              ) : (
                <div className="modal-body">
                  {selectedOrder.status === "deposited"
                    ? "Is this order ready for pickup? (Have all the items been placed aside?)"
                    : selectedOrder.status === "prepared"
                    ? 'Has this order been picked up by the customer? Selecting "Yes" will charge the customer\'s account for the remaining $' +
                      (selectedOrder.value * 0.75).toFixed(2) +
                      " to complete this order"
                    : selectedOrder.status === "checkedOut"
                    ? "Have all the items in this order been returned in good working order? Were they returned on time and are they now back in their designated place in the workshop?"
                    : ""}
                </div>
              )}
              <div className="modal-footer">
                <div
                  className="modal-footer-option"
                  onClick={this.nextOrderStatus}
                >
                  Yes
                </div>
                <div
                  className="modal-footer-option"
                  onClick={this.toggleStatusModal}
                >
                  No
                </div>
              </div>
            </div>
            <ReactTooltip />
          </div>
        ) : null}
      </div>
    );
  }
}

export default History;



// WEBPACK FOOTER //
// ./src/components/Order.js